import React from 'react';
import ResourcePage from '../../components/common/ResourcePage.jsx';
import { RESOURCES_FINANZAS_CXC } from '../../config/resources.finanzas-cxc.jsx';

export default function BancosPage() {
  return <ResourcePage cfg={RESOURCES_FINANZAS_CXC.bancos} />;
}
